import React, { FC, useState } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { useMute } from '@/scenarios/legacy-player/hooks/useMute';
import { useVolume } from '@/scenarios/legacy-player/hooks/useVolume';

import { soundPreferencesMute } from '../../../hooks/config/use-sound-preferences';

import { Slider } from './ui/slider/component';
import { getVolumeIcon } from './utils';
import styles from './styles.module.css';

interface Props {
    onEnlargementChanged?: (isEnlarged: boolean) => void;
    className?: string;
}

export const VolumeControl: FC<Props> = ({ className, onEnlargementChanged }) => {
    const { isMuted, toggleMute } = useMute();
    const [isSliderVisible, setIsSliderVisible] = useState(false);
    const showSlider = () => setIsSliderVisible(true);
    const hideSlider = () => setIsSliderVisible(false);
    const handleMouseEnter = () => {
        onEnlargementChanged?.(true);
        showSlider();
    };
    const handleMouseLeave = () => {
        onEnlargementChanged?.(false);
        hideSlider();
    };
    const { volume } = useVolume();
    const intl = useIntl();

    if (volume === undefined) {
        return null;
    }

    const toggleMuteWithSave = () => {
        toggleMute();
        soundPreferencesMute.set(!isMuted);
    };

    return (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={classnames(styles.root, className)}
        >
            <button
                onClick={toggleMuteWithSave}
                className={styles.muteButton}
                aria-label={
                    isMuted
                        ? intl.formatMessage({
                              id: 'features.player.848b17ca26178e8baeffc6fd69068cfb',
                              defaultMessage: 'Turn on sound',
                              description: 'Ариа атрибут для кнопки включить звук',
                          })
                        : intl.formatMessage({
                              id: 'features.player.eab5924313a44bcaa4f92de668c21ab1',
                              defaultMessage: 'Turn off sound',
                              description: 'Ариа атрибут для кнопки выключить звук',
                          })
                }
            >
                <img
                    src={getVolumeIcon(volume, isMuted)}
                    alt="volume"
                    className={styles.volumeIcon}
                />
            </button>
            <div
                className={classnames(
                    styles.sliderContainer,
                    isSliderVisible && styles.sliderContainerVisible
                )}
            >
                <Slider onFocus={showSlider} onBlur={hideSlider} />
            </div>
        </div>
    );
};
